import { render, staticRenderFns } from "./LeaveAttendanceDashboard.vue?vue&type=template&id=644e46d4&scoped=true"
import script from "./LeaveAttendanceDashboard.vue?vue&type=script&lang=js"
export * from "./LeaveAttendanceDashboard.vue?vue&type=script&lang=js"
import style0 from "./LeaveAttendanceDashboard.vue?vue&type=style&index=0&id=644e46d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e46d4",
  null
  
)

export default component.exports